<template>
	<div class="wrapper-content">
		<div
			v-if="isHtml"
			class="content-description"
			v-html="content.description"
		></div>
		<div
			v-else
			class="content-description"
		>{{content.description}}</div>
		<div v-if="content.urlImages">
				<div v-for="(item, index) in content.urlImage" :key="index">
					<img 
						:src="item" 
						:alt="item"
						class="content-img"
					>
			</div>
		</div>
		<div v-else-if="content.urlImage">
			<img 
				:src="content.urlImage" 
				:alt="content.urlImage"
				class="content-img"
			>
		</div>
	</div>
</template>
<script>

function isHtml() {
	return this.content.description.includes('</');
}

export default {
	name: 'content',
	computed: {
		isHtml,
	},
	props: {
		content: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
<style lang="scss" scoped>
	.wrapper-content {
		
		.content-title {
			color: color(defaultBlack);
			font-family: font(open-semibold);
			font-size: size(large);
			margin-bottom: 1.3rem;
			text-transform: uppercase;
		}

		.content-description {
			color: color(text-grey-medium);
			font-size: size(large);
			margin-bottom: 6.5rem;
		}

		.content-img {
			max-width: 100%;
		}
	}

	@media screen and (max-width: 1024px) { 
		.wrapper-content {
			.content-title, .content-description {
				font-size: size(medium);
			}
		}
	}
</style>






// WEBPACK FOOTER //
// content.vue?40e3bca3